
      import API from "!../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.110.3/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.110.3/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.110.3/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.110.3/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.110.3/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.110.3/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@1.7.12_webpack@5.110.3/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/.pnpm/less-loader@12.3.3_@rspack+core@1.7.12_less@4.9.1_webpack@5.110.3/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./app.less";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@1.7.12_webpack@5.110.3/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/.pnpm/less-loader@12.3.3_@rspack+core@1.7.12_less@4.9.1_webpack@5.110.3/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./app.less";
       export default content && content.locals ? content.locals : undefined;
